import useCreateReducer from '../use-create-reducer';

import { SET_COLLISION_DATA, SET_CURRENT_POSITION } from './constants';

const init = ({ collisionData, currentPosition }) => ({
  collisionData,
  currentPosition,
});

const actionMap = {
  [SET_COLLISION_DATA]: (state, { payload: collisionData }) => ({
    ...state,
    collisionData,
  }),

  [SET_CURRENT_POSITION]: (state, { payload: currentPosition }) => ({
    ...state,
    currentPosition,
  }),
};

const usePositioningReducer = (startingPosition) => {
  const initialState = {
    collisionData: [],
    currentPosition: startingPosition,
  };

  return useCreateReducer(actionMap, initialState, init);
};

export default usePositioningReducer;
